import { withCompInfo } from '@wix/editor-elements-integrations'
import { QuickActionBarCSSVars, QuickActionBarDefinition } from './QuickActionBar'

const getLeftValue = (skin: string, alignment: string): string | null => {
	const leftValue: Record<string, string> = {
		anchoredSkin: '160px',
		floatingSkin: alignment === 'right' ? '94px' : '144px',
		rectSkin: '148px',
	}

	return leftValue[skin] || null
}

export const css = withCompInfo<QuickActionBarCSSVars, QuickActionBarDefinition>()(
	['skin', 'compProps'],
	({ skin, compProps }) => {
		return { '--left': getLeftValue(skin, compProps.alignment) }
	}
)
